import React from 'react';
import markdownit from 'markdown-it';
import mila from 'markdown-it-link-attributes';
import moment from 'moment';
import { DATE_TIME_FORMAT, AI_ASSISTANT_FEEDBACK } from '@/constants';
import AppIcon from '@/components/app-icon';

import './index.less';

export default class ChatbotMessage extends React.Component {
  md = markdownit({
    html: true,
    xhtmlOut: true,
    breaks: true,
    langPrefix: 'language-',
    linkify: true,
    typographer: true,
    quotes: '\u201c\u201d\u2018\u2019',
    maxNesting: 20,
  }).use(mila, {
    attrs: {
      rel: 'noreferrer',
      target: '_blank',
    },
  });

  render() {
    const {
      message_type,
      content,
      sender,
      created_at,
      content_type,
      content_attributes,
      feedback,
      onFeedback,
    } = this.props;
    const isContentValid = typeof content === 'string';
    const showFeedback =
      message_type !== 0 &&
      sender &&
      isContentValid &&
      content_type === 'input_select' &&
      content_attributes?.items?.some((i) => i.title === 'ShowLikes' && i.value === true);

    return (
      <div
        className={
          'chatbot-message-container ' + (message_type === 0 ? 'user-message' : 'agent-message')
        }
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="message-bubble">
          <div
            className="message-content"
            dangerouslySetInnerHTML={{
              __html: this.md.render(isContentValid ? content : ''),
            }}
          />
          <div className="message-footer">
            {created_at && (
              <div className="message-timestamp">
                {moment(created_at * 1000).format(DATE_TIME_FORMAT)}
              </div>
            )}
            {showFeedback && (
              <div className="message-feedback">
                <span>How did I do?</span>
                <AppIcon
                  name="thumb-up"
                  className={feedback === AI_ASSISTANT_FEEDBACK.THUMBS_UP ? 'feedback-selected' : ''}
                  disabled={feedback !== undefined}
                  onClick={() => {
                    onFeedback(AI_ASSISTANT_FEEDBACK.THUMBS_UP);
                  }}
                />
                <AppIcon
                  name="thumb-down"
                  className={feedback === AI_ASSISTANT_FEEDBACK.THUMBS_DOWN ? 'feedback-selected' : ''}
                  disabled={feedback !== undefined}
                  onClick={() => {
                    onFeedback(AI_ASSISTANT_FEEDBACK.THUMBS_DOWN);
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
